import { render } from "./BewertungChipMehrfach.vue?vue&type=template&id=216a2160&scoped=true&ts=true"
import script from "./BewertungChipMehrfach.vue?vue&type=script&lang=ts"
export * from "./BewertungChipMehrfach.vue?vue&type=script&lang=ts"

import "./BewertungChipMehrfach.vue?vue&type=style&index=0&id=216a2160&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216a2160"]])

export default __exports__